var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { lock, unlock } from 'tua-body-scroll-lock';
import { getList, setSize, getItem, generateQueryString, setChannelKey, createDiv, deleteDOM, showWarning } from './../common/utils';
import databus from './../common/databus';
import biliDialog from './biliDynamicDialog';
import ucqqBrowser from './browser';
export default function templateContent(shareConfig) {
    var biliShareWrapper;
    var _a = databus.browser, isWechat = _a.isWechat, isIos = _a.isIos, isSafari = _a.isSafari, isAndroid = _a.isAndroid, isUC = _a.isUC, isQQMBrowser = _a.isQQMBrowser, isQQ = _a.isQQ;
    temInit();
    function temInit() {
        var font_size = shareConfig.font_size, shareChannelQueue = shareConfig.shareChannelQueue, templateEl = shareConfig.templateEl;
        if (isQQ)
            return showWarning('可以使用QQ内置分享功能分享给好友哦~');
        var channels = getList(isUC || isQQMBrowser ? 'toApp' : 'link', shareChannelQueue);
        var html = createTemplate(channels);
        createDiv(html, { fontSize: setSize(font_size) }, templateEl);
        biliShareWrapper = document.querySelector('#bili-share-wrap');
        eventBind();
        isShow(true);
    }
    function createTemplate(ways) {
        if (isAndroid && isUC) {
            var qzoneIdx = ways.findIndex(function (item) { return item.name === 'qzone'; });
            ways.splice(qzoneIdx, 1);
        }
        var safariHtml = "\n      <div class=\"share-box-content\">\n        <div>\u70B9\u51FB<i class=\"icons icons-safari\"></i>\u53EF\u4EE5\u5206\u4EAB\u5230\u66F4\u591A\u5730\u65B9\u54E6~</div>\n        <p>\u8FD8\u53EF\u4EE5\u6536\u85CF\u548C\u590D\u5236\u94FE\u63A5\u54E6</p>\n      </div>\n    ";
        var shareList = ways
            .map(function (item) {
            return "\n        <li>\n          <a data-type=\"" + item.name + "\" rel=\"noopener noreferrer\" class=\"share-box-item\" href=\"javascript:void(0);\">\n            <i class=\"icon icon_" + item.name + "\"></i>\n            <span>" + item.title + "</span>\n          </a>\n        </li>";
        })
            .join('');
        return "\n      <div id=\"bili-share-wrap\" class=\"bili-share-wrap hidden " + (isWechat ? 'wechat' : 'bili-share-aimation') + "\">\n        " + (isWechat ? '' : "\n          <div id=\"mobile-share\" class=\"report-wrap-module share-box bili-share-aimation\">\n            <ul class=\"share-box-list\">" + shareList + "</ul>\n            " + (isIos && isSafari ? safariHtml : '') + "\n            <div class=\"share-box-cancel\">\u53D6\u6D88</div>\n          </div>\n          ") + "\n      </div>\n    ";
    }
    function eventBind() {
        biliShareWrapper.addEventListener('click', function (ev) {
            var targetClassName = ev.target.className;
            if (targetClassName.indexOf('bili-share-wrap') >= 0 ||
                targetClassName.indexOf('share-box-cancel') >= 0) {
                shareConfig.cancel();
                isShow(false);
            }
        });
        [].forEach.call(biliShareWrapper.querySelectorAll('.share-box-item'), function (item) {
            item.addEventListener('click', (function (shareItem) { return function () {
                var success = shareConfig.success;
                var shareType = shareItem.getAttribute('data-type');
                if (shareType !== 'bili') {
                    typeof success === 'function' &&
                        success({
                            platform: shareType
                        });
                }
                if (isUC) {
                    ucqqBrowser(shareConfig, 'UC', shareType, function () {
                        setShareLink(shareType);
                    });
                }
                else if (isQQMBrowser) {
                    ucqqBrowser(shareConfig, 'QQ', shareType, function () {
                        setShareLink(shareType);
                    });
                }
                else {
                    setShareLink(shareType);
                    isShow(false);
                }
            }; })(item));
        });
    }
    function isShow(state) {
        if (state) {
            biliShareWrapper.style.display = 'block';
            lock(biliShareWrapper);
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    biliShareWrapper.classList.add('show-box');
                });
            });
        }
        else {
            if (isWechat)
                biliShareWrapper.style.display = 'none';
            biliShareWrapper.classList.remove('show-box');
            unlock(biliShareWrapper);
            deleteDOM(biliShareWrapper, 500);
        }
    }
    function setShareLink(type) {
        var linkShareConfig = returnLink(shareConfig[type], type);
        var locationUrl = '';
        switch (type) {
            case 'weibo':
                locationUrl = generateQueryString({
                    url: linkShareConfig.url,
                    title: "" + linkShareConfig.title,
                    searchPic: 'false',
                    pic: linkShareConfig.pics
                });
                break;
            case 'qzone':
                locationUrl = generateQueryString(__assign({}, linkShareConfig));
                break;
            case 'qq':
                locationUrl = generateQueryString(linkShareConfig);
                break;
            case 'baidu_tieba':
                locationUrl = generateQueryString(__assign({ pic: linkShareConfig.pics.replace('https', 'http') }, linkShareConfig));
                break;
            case 'bili':
                biliDialog(shareConfig);
                break;
        }
        location.href = "" + getItem(type).link + locationUrl;
        return false;
    }
    function returnLink(obj, type) {
        return {
            title: obj.title,
            desc: obj.desc,
            url: setChannelKey(obj.link, type, true),
            summary: obj.desc,
            pics: obj.pics,
            searchPic: 'false'
        };
    }
}
